export default {"src":"/_next/static/media/toko_saya_icon.1e629fa9.svg","height":110,"width":130};